import { LOGIN_PATH, OPR_SESSION_TOKEN } from "@/constants";
import type { ApiResult } from "@/lib/request";
import { createAutoRequest, createRequestApi } from "@/lib/request";

export const materialsHttp = createAutoRequest(
  {
    baseURL: process.env.ENV_REPLACE_API_URL || "",
    timeout: 120000,
  },
  (response) => response,
  (error) => Promise.reject(error)
);

const materialsRequest = createRequestApi(materialsHttp, {
  getToken: () => window.localStorage.getItem(OPR_SESSION_TOKEN) || "",
  loginPath: LOGIN_PATH,
});

export default materialsRequest;

export function getMaterialsAuthHeaders(): Record<string, string> {
  const token = window.localStorage.getItem(OPR_SESSION_TOKEN) || "";
  return token ? { Authorization: token } : {};
}

export async function parseMaterialsBlobError(blob: Blob): Promise<ApiResult<unknown>> {
  const text = await blob.text();
  try {
    return JSON.parse(text) as ApiResult<unknown>;
  } catch {
    return { code: -1, msg: text || "请求失败", data: null };
  }
}
